<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :cancelar-cadastro="cancelar"
      :custom-footer-style="'position: fixed;bottom: 0px;right: 0px;background-color: white;width: 100%'"
    >
      <template slot="conteudo">
        <b-row
          v-if="abaAcessada == 0"
          no-gutters
        >
          <b-col class="text-right">
            <dropdown-tag
              ref="tagProposta"
              :tags="tagsProposta"
              grupo-tags="Proposta"
              legenda="Tag Proposta"
              @enviar-pai="addTagTemplate"
            />
            <dropdown-tag
              ref="tagAssinatura"
              :tags="tagsAssinatura"
              grupo-tags="Assinatura"
              legenda="Tag Assinatura"
              @enviar-pai="addTagTemplate"
            />
            <b-btn
              v-b-tooltip.hover.lefttop
              title="Restaurar padrão"
              size="sm"
              variant="outline-primary"
              :disabled="desabilitarEnvio"
              @click="restaurarPadrao"
            >Restaurar padrão</b-btn>
          </b-col>
        </b-row>
        <b-tabs
          card
          @input="alterandoAba"
        >
          <b-tab
            ref="geral"
            no-body
            title="Editor de texto"
          >
            <div
              v-if="abaAcessada == 0"
            >
              <b-row>
                <b-col>
                  <fieldset class="font-weight-bold text-muted small">
                    Aqui você customiza o template do e-mail com as ferramentas disponíveis no editor de texto
                  </fieldset>
                </b-col>
                <b-col cols="12">
                  <hr
                    class="mx-0 mt-0 mb-2"
                    style="border-top: 1px solid #a3a4a66b !important;"
                  >
                </b-col>
                <b-col cols="12">
                  <quill-editor
                    ref="quillText"
                    v-model="form.corpoEmail"
                    :options="opcoesTextArea"
                    style="padding-bottom: 5%;"
                    toolbar="#my-toolbar"
                  />
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab
            no-body
            title="Perfil do template"
          >
            <aba-parametrizacao
              v-if="abaAcessada == 1"
              ref="parametrizacao"
              titulo="Perfil do template"
              descricao="Aqui você parametriza o perfil do template de e-mail, através desses dados é feito o vínculo com a rotina de forma automática"
              :value="form"
            />
          </b-tab>
        </b-tabs>

        <b-modal
          ref="modalUsuarioDocusign"
          size="sm"
        >
          <legend class="col-form-label pt-0">
            Selecione o usuário</legend>
          <b-select
            v-model="selecionado"
            :options="usuariosFiltrado"
            text-field="nomeCompleto"
            value-field="id"
          />
          <template #modal-footer>
            <b-btn
              variant="primary"
              class="btn btn-sm"
              :disabled="!selecionado"
              @click="setUsuarioTag"
            >
              Confirmar
            </b-btn>
          </template>
        </b-modal>
      </template>
    </cadastro-base>
  </div>
</template>

<style src="@core/scss/vue/libs/quill.scss" lang="scss"></style>
<style lang="scss">
.card-header{
  padding-bottom: 0px !important;
}

.ql-editor {
  overflow: auto;
  min-height: 300px;
  max-height: 700px;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bfbfbf;
  }
}
</style>

<script>
import { quillEditor } from 'vue-quill-editor'
import {
  required,
} from '@validations'
import {
  faPrint,
  faTags,
} from '@fortawesome/free-solid-svg-icons'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import AbaParametrizacao from './ParametrizacaoTemplateEmail.vue'
import api from '../../../services/api'

export default {
  name: 'CadastroTemplate',
  components: {
    quillEditor,
    CadastroBase,
    AbaParametrizacao,
    DropdownTag: () => import('@/shared/components/dropdown-tag/DropdownTag.vue'),
  },
  data() {
    return {
      faPrint,
      faTags,
      required,
      form: {
        template: '',
        tipos: [],
        corpoEmail: '',
      },
      abaAcessada: 0,
      templateOptions: [
        { value: 'contrato', text: 'Contrato' },
      ],
      propostaOptions: [
        { value: 'constituicao', text: 'Proposta honorários empresas em constituição' },
        { value: 'transeferencia', text: 'Proposta honorários empresas em transferência' },
      ],
      tagsProposta: ['Pessoa', 'Lista de proposta e serviços', 'Link (Clique aqui)'],
      tagsAssinatura: ['Assinatura'],
      quill: {},
      opcoesTextArea: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote', 'code-block'],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }], // outdent/indent

            [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],
          ],
        },
        placeholder: 'Insira o template padrão para o envio de e-mail aqui!',
      },
      optionsQuill: {
        modules: {
        },
      },
      usuarios: [],
      usuariosFiltrado: [],
      tagAtual: '',
      selecionado: null,
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    carregar(id) {
      api.getTemplateById(id)
        .then(payload => {
          this.form = payload.data
        })
        .catch(err => {
          throw err
        })
    },
    cancelar() {
      this.$router.go(-1)
    },
    salvar() {
      return new Promise((resolve, reject) => {
        if (!this.form.descricao || this.form.descricao === '' || this.form.template === undefined || this.form.tipoEmail === undefined || this.form.tipos === undefined || this.form.tipos.length === 0) {
          this.$erro('Preencha os campos da aba perfil corretamente')
        } else if (this.state === 'novo') {
          api.salvarTemplate(this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Template cadastrado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        } else {
          api.updateTemplate(this.form.id, this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Template alterado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    addTagTemplate(value) {
      this.quill = this.$refs.quillText.quill
      this.quill.insertText(this.quill.getSelection(true), value, 'bold', true)
      this.quill.setSelection(this.quill.getSelection(true).index)
      this.quill.insertText(this.quill.getSelection(true), ' ', 'bold', false)
    },
    setUsuarioTag() {
      const usuario = this.usuarios.find(find => find.id === this.selecionado)
      this.quill = this.$refs.quillText.quill
      const tag = this.tagAtual.replace('}', ` ${usuario.id} - ${usuario.nomeCompleto}}`)
      this.quill.insertText(this.quill.getSelection(true), tag, 'bold', true)
      this.quill.setSelection(this.quill.getSelection(true).index)
      this.quill.insertText(this.quill.getSelection(true), ' ', 'bold', false)
      this.selecionado = null
      this.$refs.modalUsuarioDocusign.hide()
    },
    alterandoAba(newIndex) {
      this.abaAcessada = newIndex
    },
    restaurarPadrao() {
      if (this.form.tipoEmail === undefined) {
        this.$erro('Para restaurar o padrão é necessario selecionar o tipo de e-mail')
      } else {
        api.getPadrao(this.form.tipoEmail).then(payload => {
          this.form.corpoEmail = payload.data
        },
        this.$sucesso('Restaurado padrão com sucesso'))
          .catch(err => {
            this.$erro(err)
          })
      }
    },
  },
}
</script>
